/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_ContactInputs */



/**
* | output |
* | --- |
* | "Contact" |
*
* @param {Profile_ContactInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const profile_contact = /** @type {((inputs?: Profile_ContactInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_ContactInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Contact")
	if (locale === "es") return /** @type {LocalizedString} */ ("Contacto")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Contato")
	if (locale === "it") return /** @type {LocalizedString} */ ("Contatto")
	return /** @type {LocalizedString} */ ("Contact")
});